export var JournalEntryStatus;
(function (JournalEntryStatus) {
    JournalEntryStatus["pending"] = "pending";
    JournalEntryStatus["processing"] = "processing";
    JournalEntryStatus["posted"] = "posted";
    JournalEntryStatus["error"] = "error";
})(JournalEntryStatus || (JournalEntryStatus = {}));
//# sourceMappingURL=journal-entry-status.js.map